module.exports = __webpack_public_path__ + "img/slide-1-sharpen-patient-2.9b089179.png";